export class Notify {

	addLoader (loadedElement) {
		$(loadedElement).addClass("_loader");
		$(loadedElement).append("<div class='_loader__container'><div class='_loader__icon'><svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16 2C15.16 2 14.6 2.56 14.6 3.4V6.9C14.6 7.74 15.16 8.3 16 8.3C16.84 8.3 17.4 7.74 17.4 6.9V3.4C17.4 2.56 16.84 2 16 2Z' fill='#002D80'/><path d='M8.57997 10.54C8.85997 10.82 9.27997 10.96 9.55997 10.96C9.83997 10.96 10.26 10.82 10.54 10.54C11.1 9.98002 11.1 9.14002 10.54 8.58002L8.01997 6.06002C7.45997 5.50002 6.61997 5.50002 6.05997 6.06002C5.49997 6.62002 5.49997 7.46002 6.05997 8.02002L8.57997 10.54Z' fill='#002D80'/><path d='M8.3 16C8.3 15.16 7.74 14.6 6.9 14.6H3.4C2.56 14.6 2 15.16 2 16C2 16.84 2.56 17.4 3.4 17.4H6.9C7.6 17.4 8.3 16.84 8.3 16Z' fill='#002D80'/><path d='M8.57993 21.46L6.19993 23.84C5.63993 24.4 5.63993 25.24 6.19993 25.8C6.47993 26.08 6.89993 26.22 7.17993 26.22C7.45993 26.22 7.87993 26.08 8.15993 25.8L10.5399 23.42C11.0999 22.86 11.0999 22.02 10.5399 21.46C9.97993 20.9 9.13993 20.9 8.57993 21.46Z' fill='#002D80'/><path d='M16 23.7C15.16 23.7 14.6 24.26 14.6 25.1V28.6C14.6 29.44 15.16 30 16 30C16.84 30 17.4 29.44 17.4 28.6V25.1C17.4 24.4 16.84 23.7 16 23.7Z' fill='#002D80'/><path d='M23.42 21.46C22.86 20.9 22.02 20.9 21.46 21.46C20.9 22.02 20.9 22.86 21.46 23.42L23.84 25.8C24.12 26.08 24.54 26.22 24.82 26.22C25.1 26.22 25.52 26.08 25.8 25.8C26.36 25.24 26.36 24.4 25.8 23.84L23.42 21.46Z' fill='#002D80'/><path d='M28.6 14.6H25.1C24.26 14.6 23.7 15.16 23.7 16C23.7 16.84 24.26 17.4 25.1 17.4H28.6C29.44 17.4 30 16.84 30 16C30 15.16 29.44 14.6 28.6 14.6Z' fill='#002D80'/><path d='M22.44 10.96C22.86 10.96 23.14 10.82 23.42 10.54L25.8 8.16002C26.36 7.60002 26.36 6.76002 25.8 6.20002C25.24 5.64002 24.4 5.64002 23.84 6.20002L21.46 8.58002C20.9 9.14002 20.9 9.98002 21.46 10.54C21.74 10.82 22.16 10.96 22.44 10.96Z' fill='#002D80'/></svg></div></div>");
	}
	removeLoader (loadedElement) {
		$(loadedElement).removeClass("_loader");
		$(loadedElement).find("._loader__container").remove();
	}
	
	constructor() {
		let url = new URL(window.location.href);
		this.mid = url.searchParams.get('selected_mod_id');
		this.id = 0;
	}

	updateTableRow(table, id, data)
	{
		let tbody = $('table[data-table = ' + table + '] tbody');
		let tr = tbody.find('tr[data-id = ' + id + ']');
		for (const [i, value] of data.entries()) {
			tr.find('td[data-field = ' + i + ']').text(value);
		}
	}

	done(id, parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/8/',
			dataType: 'json',
			data: {action: 'done', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$(parent).closest('tr').fadeOut();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	checkAdd(id, parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/8/',
			dataType: 'html',
			data: {action: 'checkAdd', id: id},
			success: function(html)
			{
				if ($('.popup-notify-check-add').length)
				{
					$('.popup-notify-check-add .popup__container').replaceWith($(html).find('.popup__container'));
				}
				else
				{
					let p = $(html);
					$('body').append(p);
					console.log(p);
					p.on("click", function (e) {
						var callbackPopup = $(".popup__card")
						if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
							p.removeClass("active");
							$("body").removeClass("no-scroll");
						};
					});
				}

				vform.applyEvents($(".popup-notify-check-add"));

				$(".popup-notify-check-add .popup__close, .popup-notify-check-add .popup__cancel").on("click", function(e){
					$("body").removeClass("no-scroll");
					$(this).closest(".popup").removeClass("active");
				});

				$(".popup-notify-check-add").addClass("active");
				$("body").addClass("no-scroll");
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	add(type, id, parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/8/',
			dataType: 'html',
			data: {action: 'add', type: type, id: id},
			success: function(html)
			{
				if ($('.popup-notify-check-add').length)
				{
					$('.popup-notify-check-add .popup__container').replaceWith($(html).find('.popup__container'));
				}
				else
				{
					let p = $(html);
					$('body').append(p);
					console.log(p);
					p.on("click", function (e) {
						var callbackPopup = $(".popup__card")
						if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
							p.removeClass("active");
							$("body").removeClass("no-scroll");
						};
					});
				}

				vform.applyEvents($(".popup-notify-check-add"));

				$(".popup-notify-check-add .popup__close, .popup-notify-check-add .popup__cancel").on("click", function(e){
					$("body").removeClass("no-scroll");
					$(this).closest(".popup").removeClass("active");
				});

				$(".popup-notify-check-add").addClass("active");
				$("body").addClass("no-scroll");
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	submitCheckAdd(parent)
	{
		let _this = this;
		let formData = new FormData(parent);
		let id = $(parent).find('input[name=old_id]').val();
		_this.addLoader($(parent).closest('.card'));

		$.ajax({
			type: "POST",
			url: '/vsop/ajax/8/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=submitCheckAdd',
			success: function(res)
			{
				if (res.success)
				{
					formData.append('id', res['last']);
					_this.updateTableRow('notify', id, formData);
					$(parent).html('<h3>Напоминание сохранено</h3>');
					$(".popup-notify-check-add").removeClass("active");
					$("body").removeClass("no-scroll");
				}
				else
				{
					alert(res.error);
				}

				_this.removeLoader($(parent).closest('.card'));
			},
			error: function(e)
			{
				alert(e);
				_this.removeLoader($(parent).closest('.card'));
			}
		});
	}

	submitAdd(parent)
	{
		let _this = this;
		let formData = new FormData(parent);
		_this.addLoader($(parent).closest('.card'));

		$.ajax({
			type: "POST",
			url: '/vsop/ajax/8/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=submitAdd',
			success: function(res)
			{
				if (res.success)
				{
					formData.append('id', res['last']);
					//-_this.updateTableRow('notify', id, formData);
					if ($('table[data-table="notify"]').length && !$('table[data-table="notify"]').closest('.popup').length)
					{
						location.reload();
					}
					else
					{
						let id = $(parent).find('input[name=slt_objects]').val()
						search.showObject(id);
					}
					$(parent).html('<h3>Напоминание добавлено</h3>');
					$(".popup-notify-check-add").removeClass("active");
					$("body").removeClass("no-scroll");
				}
				else
				{
					alert(res.error);
				}

				_this.removeLoader($(parent).closest('.card'));
			},
			error: function(e)
			{
				alert(e);
				_this.removeLoader($(parent).closest('.card'));
			}
		});
	}
}